import axios from 'axios'
import Auth from './Auth'

// Best-effort observation, not authorization. Send only when visible and recently
// interacted with, not an endless idle-tab heartbeat. Never send identity/time.
export function startMemberActivityTracking(): () => void {
  let lastInteraction = Date.now()
  let lastAttempt = 0
  let inFlight = false
  const interval = 5 * 60 * 1000
  const markInteraction = () => { lastInteraction = Date.now() }
  const observe = async () => {
    const now = Date.now()
    const token = Auth.getToken()?.token
    if (!token || document.visibilityState !== 'visible' || inFlight ||
        now - lastAttempt < interval || now - lastInteraction > interval) return
    lastAttempt = now
    inFlight = true
    try {
      const base = (process.env.VUE_APP_BASE_URL || '').replace(/\/$/, '')
      await axios.post(`${base}/user/private/api/v1/user/activity`, {}, {
        headers: { Authorization: `Bearer ${token}` }, timeout: 10000,
      })
    } catch (_) {
      // Telemetry failure must not sign out users or interrupt old class access.
    } finally { inFlight = false }
  }
  const onInteraction = () => { markInteraction(); void observe() }
  const onVisible = () => {
    if (document.visibilityState === 'visible') onInteraction()
  }
  window.addEventListener('pointerdown', onInteraction, { passive: true })
  window.addEventListener('keydown', onInteraction)
  document.addEventListener('visibilitychange', onVisible)
  const timer = window.setInterval(observe, interval)
  void observe()
  return () => {
    window.clearInterval(timer)
    window.removeEventListener('pointerdown', onInteraction)
    window.removeEventListener('keydown', onInteraction)
    document.removeEventListener('visibilitychange', onVisible)
  }
}
